import { FormEvent, useCallback, useEffect, useState } from "react";
import { MesesDoAnoEnum } from "../../../enums/mesesDoAno";
import { ISelectOptions } from "../../../types/inputs";
import {
  IListarLojasGetProps,
  IProducaoTipoClienteDTO,
  IProducaoTipoClientGetProps,
} from "../../../types/gerenciamento";
import { Gerenciamento } from "../../../services/Gerenciamento";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { Exportar } from "../../../services/Exportar";
import { IExportarProducaoDespachanteProps } from "../../../types/exportar";

const currentYear = new Date().getFullYear();
const currentMoth = new Date().getMonth() + 1;

const mothOptions: ISelectOptions[] = Object.entries(MesesDoAnoEnum)
  .filter((i) => !isNaN(parseInt(i[0])))
  .map((v) => ({
    value: v[0],
    label: v[1] as string,
  }));

const yearOptions = Array.from({ length: currentYear - 2019 }, (_, index) => {
  const year = 2020 + index;
  return { value: year, label: year.toString() };
});

export const useProductivityServiceByClient = () => {
  const [filter, setFilter] = useState<IProducaoTipoClientGetProps>({
    ano: currentYear,
    mes: currentMoth,
  });
  const [empresasOptions, setEmpresasOptions] = useState<ISelectOptions[]>(
    [] as ISelectOptions[]
  );
  const [lojasOptions, setLojaOptions] = useState<ISelectOptions[]>(
    [] as ISelectOptions[]
  );
  const [producao, setProducao] = useState<IProducaoTipoClienteDTO>(
    {} as IProducaoTipoClienteDTO
  );

  const { setIsLoad } = useContextSite();

  const getLojas = (props: IListarLojasGetProps) => {
    Gerenciamento.listarLojas({ empresa: props?.empresa })
      .then(({ data }) => {
        const options = data.map((i) => ({ value: i, label: i }));
        setLojaOptions(options);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      );
  };

  const getEmpresas = useCallback(() => {
    Gerenciamento.listarEmpresas()
      .then(({ data }) => {
        const options = data.map((i) => ({ value: i, label: i }));
        setEmpresasOptions(options);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      );
  }, []);

  async function handleDownDoc() {
    setIsLoad(true);

    const PAYLOAD: IExportarProducaoDespachanteProps = {
      ano: filter?.ano,
      mes: filter?.mes,
      cidade: filter?.cidade,
      empresa: filter?.empresa,
    };

    Exportar.Producao_despachante(PAYLOAD).finally(() => {
      setIsLoad(false);
    });
  }

  function getProducao(props?: IProducaoTipoClientGetProps) {
    setIsLoad(true);

    Gerenciamento.producaoTipoCliente(props)
      .then(({ data }) => {
        setProducao(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function handleFilter(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    getProducao(filter);
  }

  useEffect(() => {
    if (filter.empresa) {
      getLojas({ empresa: filter.empresa });
      return;
    }

    setFilter((prev) => ({ ...prev, cidade: "" }));
    setLojaOptions([]);
  }, [filter?.empresa]);

  useEffect(() => {
    getProducao(filter);
    getEmpresas();
  }, []);

  return {
    mothOptions,
    yearOptions,
    filter,
    setFilter,
    empresasOptions,
    lojasOptions,
    handleFilter,
    producao,
    handleDownDoc,
  };
};
